import { Button, Col, Form, Input, Row, Space, theme, Table, message, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import ModalAddAndEdit from './component/ModalAddAndEdit';
import { customers_create, customers_update, getListBranches, getListCustomers} from '../../services/apis';
import { FORMAT_DATE, HeaderTableCus, TYPE_MODAL } from '../../constants/constants';
import { filterOption } from '../../utils/funcHelper';
import { PlusCircleFilled, SearchOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const ListCustomerPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [itemSelected, setItemSelected] = useState();
    const [typeModal, setTypeModal] = useState();
    const [titleModal, setTitleModal] = useState('');
    const [listBranch, setListBranch] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [pageCurrent, setPageCurrent] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(20);
    const columns = [
        {
            title: 'STT',
            key: 'STT',
            width: 80,
            align: 'center',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Tên khách hàng',
            dataIndex: 'full_name',
            key: 'full_name',
            render: (text, record, index) => <a onClick={() => handleEditCustomer(record)} style={{ paddingLeft: 12, paddingRight: 12 }}>{text}</a>,
        },
        {
            title: 'SĐT chính',
            dataIndex: 'phone',
            key: 'phone',
            align: 'center',
            render: (text, record, index) => <div>{text}</div>,
        },
        {
            title: 'SĐT khác',
            dataIndex: 'other_phone',
            key: 'other_phone',
            align: 'center',
            render: (text, record, index) => <div>{text}</div>,
        },
        {
            title: 'Giới tính',
            dataIndex: 'gender',
            key: 'gender',
            width: 100,
            align: 'center',
            render: (text, record, index) => 
                <span>{text === "female" ? "Nữ" : "Nam"}</span>
            ,
        },
        {
            title: 'Ngày sinh',
            dataIndex: 'birthday',
            key: 'birthday',
            align: 'center',
            render: (text, record, index) => 
                <span>{text && text !== '0000-00-00' ? dayjs(text).format(FORMAT_DATE.DDMMYYYY) : 'Chưa có'}</span>
            ,
        },
        {
            title: 'Địa chỉ',
            dataIndex: 'address',
            key: 'address',
            render: (text, record, index) => (
                <span style={{ paddingLeft: 12, paddingRight: 12 }}>{text}</span>
            ),
        },
        {
            title: 'Chi nhánh',
            dataIndex: 'branch_name',
            key: 'branch_name',
            render: (text, record, index) => (
                <span style={{ paddingLeft: 12, paddingRight: 12 }}>{text}</span>
            ),
        },
        {
            title: 'Ngày tạo',
            dataIndex: 'created_at',
            key: 'created_at',
            align: 'center',
            render: (text, record, index) => <div style={{ paddingLeft: 12, paddingRight: 12 }}>{text}</div>,
        }
    ];

    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };

    const handleEditCustomer = (record) => {
        setItemSelected(record);
        setTypeModal(TYPE_MODAL.EDIT);
        setShowModal(true);
        setTitleModal('Sửa thông tin khách hàng');
    }

    const getDataBranches = async () => {
        try {
            const params = {
                keyword: ''
            }
            const res = await getListBranches(params);
            if (res && res.status === 1) {
                setListBranch(res?.data?.data?.map(item => ({ ...item, value: item.id, label: item.name })));
            } else {
                setListBranch([]);
            }
        } catch (error) {
            console.log('error', error);
        }
    }

    const getDataCustomers = async (page, showLoading, size) => {
        try {
            const params = {
                keyword: form.getFieldValue('name') ?? '',
                branch_id: form.getFieldValue('branch_id') ?? null,
                limit: size ?? currentPageSize,
                currentPage: page,
            }
            if (showLoading) setLoading(true);
            const res = await getListCustomers(params);
            if (showLoading) setLoading(false);
            if (res && res.status === 1) {
                setData([...res?.data?.data]);
                setTotalItems(res?.data?.pagination?.total_records ?? 0);
            } else {
                message.error(res.message);
                setData([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }


    }

    const onFinish = async (dataForm) => {
        setPageCurrent(1);
        getDataCustomers(1, true, currentPageSize);
    };

    const handleAddCustomer = async () => {
        setItemSelected(null);
        setTypeModal(TYPE_MODAL.ADD);
        setShowModal(true);
        setTitleModal('Thêm mới khách hàng');
    }

    const callApiUpdateCustomer = async (data) => {
        try {
            setLoading(true);
            const res = await customers_update(data);
            setLoading(false);
            if (res && res.status === 1) {
                setPageCurrent(1);
                getDataCustomers(1, true, currentPageSize);
            } else {
                message.error(res?.msg || 'Cập nhật khách hàng thất bại');
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
        }
    }
    const callApiCreateCustomer = async (data) => {
        try {
            setLoading(true);
            const res = await customers_create(data);
            setLoading(false);
            if (res && res.status === 1) {
                message.success('Thêm mới khách hàng thành công');
                setPageCurrent(1);
                getDataCustomers(1, true, currentPageSize);
            } else {
                message.error(res?.msg || 'Thêm mới khách hàng thất bại');
            }
        } catch (error) {
            console.log('error', error);
            setLoading(false);
        }
    }
    const handleOnSave = async (data) => {
        setShowModal(false);
        if (typeModal === TYPE_MODAL.EDIT) {
            callApiUpdateCustomer(data);
        } else {
            callApiCreateCustomer(data);
        }
    }

    useEffect(() => {
        setLoading(true);
        Promise.all([getDataBranches(), getDataCustomers(1, false, currentPageSize)]).finally(() => setLoading(false));
    }, [])

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            name={'name'}
                        >
                            <Input placeholder={'Nhập tên, sđt'} />
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item
                            name="branch_id"
                        >
                            <Select
                                showSearch
                                allowClear
                                placeholder={'Chọn cơ sở'}
                                style={{ width: '100%', height: 40 }}
                                defaultActiveFirstOption={false}
                                filterOption={filterOption}
                                notFoundContent={null}
                                options={listBranch}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={4}>
                        <Space size="small">
                            <Button type="primary" htmlType="submit" icon={<SearchOutlined />}>
                                Tìm kiếm
                            </Button>
                            <Button
                                icon={<PlusCircleFilled />}
                                onClick={handleAddCustomer}
                                danger
                            >
                                Thêm mới khách hàng
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            <Table
                components={HeaderTableCus}
                columns={columns}
                dataSource={data}
                rowKey={(record) => record?.id}
                bordered
                rowClassName={() => 'custom-row'}
                pagination={{
                    pageSize: currentPageSize,
                    current: pageCurrent,
                    total: totalItems,
                    onChange: (page, size) => {
                        setPageCurrent(page);
                        getDataCustomers(page, true, size);
                    },
                    showSizeChanger: true,
                    showTotal: (total) => `Tổng ${total} khách`,
                    pageSizeOptions: ['20', '30', '50'],
                    onShowSizeChange: (current, size) => {
                        setCurrentPageSize(size);
                        setPageCurrent(1);
                        getDataCustomers(1, true, size);
                    }
                }}
                scroll={{y: 600}}
            />
            <LoadingBase loading={loading} />
            <ModalAddAndEdit
                visible={showModal}
                onCancel={() => setShowModal(false)}
                data={itemSelected}
                title={titleModal}
                onSave={handleOnSave}
                type={typeModal}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(ListCustomerPage);